@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.content {
  overflow-y: auto;
}

.subscription-header {
  justify-content: space-between;
}

.header-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: @space-8;
}

.past-invoices-link {
  display: block;
  height: 24px;
  line-height: 24px;
  margin-top: 11px;
}
